// extracted by mini-css-extract-plugin
export default {"description":"SaleDescription_description__20yZ+"};